import React from "react";
import { StyleSheet, View } from "react-native";

export interface DietaryIconProps {
  size?: number;
}

/**
 * The box every dietary mark sits in, SVG or PNG alike. It carries the accessible label — on a
 * plain `View`, which both platforms honour, rather than on `<Svg>`, which react-native-svg's
 * web build would pass through to the DOM as an unknown attribute.
 */
export function DietaryMark({
  size,
  label,
  children,
}: {
  size: number;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <View
      accessible
      accessibilityRole="image"
      accessibilityLabel={label}
      style={[styles.mark, { width: size, height: size }]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  mark: {
    flexShrink: 0,
  },
});
